import "../../css/profile.css";
import {
  AppBar,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  InputAdornment,
  IconButton,
  MenuItem,
  Paper,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FileCopy from "@material-ui/icons/FileCopyRounded";
import MomentUtils from "@date-io/moment";
import "moment/locale/vi";
import "moment/locale/en-ca";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";

import { _parsePhoneNumber } from "../../partials/validateNumber";
import Loading from "../loading";
import Snackbar from "../snackbar";
import { styles } from "./styles";
import InputFileReader from "../fileReader";
import Header from "../../partials/header";
import InputFormat from "../../partials/inputForm";
import Dialog from "../dialog";
import validator from "validator";
import DevelopAccount from "./developAccount";
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 24 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        email: "",
        username: "",
        countryCode: this.props.defaultCountryCode || "+84",
        roleId: {
          role: "user",
          loginAdmin: 1,
          loginFrontend: 1,
          module: {},
        },
        firstName: "",
        lastName: "",
        fullName: "",
        avatarImage: "",
        sex: "",
        address: "",
        dob: moment(),
      },
      tab: 0,
      password: {
        newPassword: "",
        confirmNewPassword: "",
        currentPassword: "",
      },
      apiKey: {},

      showApiKey: false,
    };
    this.mAPIKey = React.createRef();
  }

  async componentDidMount() {
    if (this.props.location.search === "?password") this.setState({ tab: 1 });
    let user = this.state.user;
    user = this.props.user;
    this.setState({ user });
    let check = await this.props.getAPIkey();
    if (check && check.code) {
      let data = this.props.apiKey;
      delete data.secretKey;
      this.setState({ apiKey: data });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user) {
      let user = this.state.user;
      user = nextProps.user;
      this.setState({ user });
    }
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      let { user } = this.state;
      user.countryCode = nextProps.defaultCountryCode;
      this.setState({ user: user });
    }
  }

  handleTab = (event, value) => {
    this.setState({ tab: value });
  };
  handleInputChange = (event) => {
    const target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (name === "sex" && value === -1) value = 0;
    let user = this.state.user;
    user[name] = value;
    this.setState({ user });
  };

  handleInputPasword = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let password = this.state.password;
    password[name] = value;
    this.setState({ password });
  };
  getFormattedDate = (date) => {
    return moment(date).format("DD/mm/YYYY");
  };
  handleSubmit = async () => {
    let { t } = this.props;
    if (!validator.isEmail(this.state.user.email)) {
      this.mSnackbar.handleClick(
        `${this.state.user.email} ` + t("profile_email_is_not_valid"),
        "warning"
      );
    } else {
      this.loading.startLoading();
      let check = await this.props.userDispatch.updateUser({
        sex: this.state.user.sex,
        dob: this.state.user.dob
          ? moment(new Date(this.state.user.dob)).format("YYYY-MM-DD")
          : null,
        firstName: this.state.user.firstName,
        lastName: this.state.user.lastName,
        email: this.state.user.email,
        address: this.state.user.address,
      });
      this.loading.stopLoading();
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("profile_successfully"));
      } else if (check.error === 1198)
        this.mSnackbar.handleClick(
          t("profile_update_firstName_lastName_required")
        );
      else {
        this.mSnackbar.handleClick(t("profile_unsuccessfully"), "error");
      }
      this.setState({ user: { ...this.state.user, ...this.props.user } });
    }
  };

  handlePassword = async () => {
    let { t } = this.props;
    if (
      this.state.password.newPassword !== this.state.password.confirmNewPassword
    )
      this.mSnackbar.handleClick(
        t("profile_change_password_password_confirm_does_not_match"),
        "warning"
      );
    else if (this.state.password.newPassword.length < 6)
      this.mSnackbar.handleClick(
        t(
          "profile_change_password_new_password_must_be_at_least_6_characters_long"
        ),
        "warning"
      );
    else {
      let { t } = this.props;
      this.loading.startLoading();
      let check = await this.props.userDispatch.changePassword(
        this.state.password
      );
      this.loading.stopLoading();
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("profile_successfully"));
      } else if (check.code === 0 && check.error === 1005)
        this.mSnackbar.handleClick(
          t("profile_change_current_password_is_incorrect"),
          "error"
        );
      else {
        this.mSnackbar.handleClick(
          t("profile_unsuccessfully") + " " + check.message,
          "error"
        );
      }
      this.setState({
        password: {
          newPassword: "",
          confirmNewPassword: "",
          currentPassword: "",
        },
      });
    }
  };
  imageSelect = async (imageURL) => {
    let { t } = this.props;
    this.loading.startLoading();
    let checkUpdate = await this.props.userDispatch.updateImgURL({
      avatarImage: imageURL,
    });
    this.loading.stopLoading();
    if (checkUpdate) this.mSnackbar.handleClick(t("profile_successfully"));
    else this.mSnackbar.handleClick(t("profile_unsuccessfully"), "error");
  };
  handleUploadImage = async (files) => {
    let { t } = this.props;
    this.loading.startLoading();
    let checkUpload = await this.props.uploadDispatch.saveStorage({
      files: files,
      code: this.props.user.userCode,
      type: "profile",
      imgPre: this.props.user.avatarImage,
    });
    if (checkUpload.code === 1) {
      let checkUpdate = await this.props.userDispatch.updateImgURL({
        avatarImage: checkUpload.data.previewLink,
      });
      this.loading.stopLoading();
      if (checkUpdate) this.mSnackbar.handleClick(t("profile_successfully"));
      else this.mSnackbar.handleClick(t("profile_unsuccessfully"), "error");
    } else {
      this.loading.stopLoading();
      this.mSnackbar.handleClick(
        t("profile_unsuccessfully") + " " + checkUpload.message,
        "error"
      );
    }
  };
  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };
  handleShowAPIKey = () => {
    const { showApiKey } = this.state;
    this.setState({ showApiKey: !showApiKey });
  };
  handleAPIkey = (e) => {
    const { apiKey } = this.state;
    apiKey[e.target.name] = e.target.value;
    this.setState({ apiKey });
  };
  handleDeleteAPIKey = async (e) => {
    this.loading.startLoading();
    const _this = this;
    const { t } = this.props;
    // let check = await this.props.deleteAPIkey({ snackbar: this.snackbar });
    let check = await this.props.deleteAPIkey();
    if (check && check.code === 1) {
      this.setState({
        apiKey: {
          apiKey: "",
          secretKey: "",
        },
      });
      this.snackbar(t("profile_api_key_delete_successfully"));
    } else this.snackbar(check.message);
    this.mDialog.handleDialogClose();
    _this.loading.stopLoading();
  };
  handleGeneralAPI = async () => {
    this.loading.startLoading();
    const _this = this;
    const { secretKey } = this.state.apiKey;
    const { t } = this.props;
    if (secretKey) {
      let check = await this.props.createAPIkey({ secretKey: secretKey });
      if (check && check.code) {
        _this.setState({ apiKey: _this.props.apiKey });
        this.snackbar(t("profile_api_key_create_successfully"));
      }
    } else {
      _this.snackbar(t("profile_pls_enter_secret_key"), "warning");
    }
    _this.loading.stopLoading();
  };
  deleteAvatar = async () => {
    let { t } = this.props;
    if (this.props.user.avatarImage) {
      this.loading.startLoading();
      let checkUpdate = await this.props.userDispatch.updateImgURL({
        avatarImage: "",
        imgPre: this.props.user.avatarImage,
      });
      this.loading.stopLoading();
      if (checkUpdate) this.mSnackbar.handleClick(t("profile_successfully"));
      else this.mSnackbar.handleClick(t("profile_unsuccessfully"), "error");
    } else {
      console.log("Not found image");
    }
  };
  copyToClipboard = (e) => {
    this.mAPIKey.current.select();
    document.execCommand("copy");
    e.target.focus();
    this.snackbar("Copied!");
  };
  createDevelopAccountSuccess = () => {};
  render() {
    const { classes, i18n, t } = this.props;

    const { tab, user, showApiKey, apiKey } = this.state;
    const fullName = user.firstName.concat(" ", user.lastName);
    const phone = _parsePhoneNumber(
      this.props.user.countryCode,
      this.props.user.username
    ).format_internal;
    const avatarImage = this.props.user.avatarImage || "/images/noneImage.svg";
    let roleId = user.roleId,
      permission = {};
    permission = this.props.module;
    return (
      <MuiPickersUtilsProvider
        libInstance={moment}
        utils={MomentUtils}
        locale={i18n.language === "vn" ? "vi" : "en"}
      >
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("profile_api_key_cancel")}
          agree={t("profile_api_key_delete")}
          title={t("profile_api_key_notify")}
          content={t(
            "profile_api_key_api_will_be_delete_immediately_you_can_not_undo_this_action"
          )}
          action={this.handleDeleteAPIKey}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Header session={t("sidebar_manage")} title={t("profile_profile")} />
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Card className={classes.card + " card"}>
              <CardContent className={classes.cardHeader + " card-header"}>
                <InputFileReader
                  onRef={(id) => (this.InputFileReader = id)}
                  defaultImg={avatarImage}
                  style={classes}
                  type="notPreview"
                  update={this.handleUploadImage}
                  selectStorageMode={true}
                  imageSelect={this.imageSelect}
                  delete={this.deleteAvatar}
                />

                <CardHeader
                  title={fullName}
                  classes={{
                    title: classes.title,
                    subheader: classes.subheader,
                  }}
                  subheader={user.email}
                />
                {/* <div>
                <div>{fullName}</div>
                <div>
                  <span>{user.email}</span>
                </div>
              </div> */}
              </CardContent>
              <CardContent className={"card-content"}>
                {user.sex !== null ? (
                  <div className="row">
                    <Typography
                      gutterBottom
                      variant="body2"
                      component="h4"
                      classes={{ root: classes.rootTypography }}
                    >
                      {t("profile_gender")}
                    </Typography>
                    <Typography component="p">
                      {user.sex ? t("profile_female") : t("profile_male")}
                    </Typography>
                  </div>
                ) : (
                  ""
                )}
                {user.username ? (
                  <div className="row">
                    <Typography
                      gutterBottom
                      variant="body2"
                      component="h4"
                      classes={{ root: classes.rootTypography }}
                    >
                      {t("profile_phone")}
                    </Typography>
                    <Typography component="p">{phone}</Typography>
                  </div>
                ) : (
                  ""
                )}
                {user.address ? (
                  <div className="row">
                    <Typography
                      gutterBottom
                      variant="body2"
                      component="h4"
                      classes={{ root: classes.rootTypography }}
                    >
                      {t("profile_address")}
                    </Typography>
                    <Typography component="p">{user.address}</Typography>
                  </div>
                ) : (
                  ""
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid
            item
            xs={12}
            sm={8}
            md={9}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Paper
              className={classes.paper + " profile paper-right"}
              classes={{ root: classes.rightSide }}
            >
              <AppBar position="static" color="default">
                <Tabs
                  value={tab}
                  onChange={this.handleTab}
                  indicatorColor="secondary"
                  classes={{ fixed: classes.tabsFixed }}
                  scrollButtons="on"
                  variant="scrollable"
                  // textColor="secondary"
                  // classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                >
                  <Tab
                    // disableRipple
                    label={t("profile_information")}
                    // classes={{ root: classes.tabRoot, selected: classes.selected }}
                  />
                  <Tab
                    // disableRipple
                    label={t("profile_password")}
                    // classes={{ root: classes.tabRoot, selected: classes.selected }}
                  />
                  {permission.apiKey &&
                  permission.apiKey.view &&
                  roleId.role === "ownerSpa" ? (
                    <Tab
                      // disableRipple
                      disabled={
                        permission.apiKey &&
                        permission.apiKey.view &&
                        roleId.role === "ownerSpa"
                          ? false
                          : true
                      }
                      label={t("profile_apikey")}
                      // classes={{ root: classes.tabRoot, selected: classes.selected }}
                    />
                  ) : (
                    ""
                  )}
                  {(roleId.role === "ownerSpa" ||
                    roleId.role === "employeeSpa") && (
                    <Tab
                      // disableRipple
                      label={t("developer_account_developer_account")}
                      // classes={{ root: classes.tabRoot, selected: classes.selected }}
                    />
                  )}
                </Tabs>
              </AppBar>
              <Paper className={classes.paper + " profile tab-container"}>
                {tab === 0 && (
                  <TabContainer>
                    <Grid container spacing={3} className={" tab-profile"}>
                      <Grid item xs={12} sm={6}>
                        <InputFormat
                          required
                          label={t("profile_first_name")}
                          placeholder={t("profile_first_name")}
                          name="firstName"
                          margin="normal"
                          value={user.firstName === null ? "" : user.firstName}
                          onChange={this.handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputFormat
                          required
                          label={t("profile_last_name")}
                          placeholder={t("profile_last_name")}
                          name="lastName"
                          margin="normal"
                          value={user.lastName === null ? "" : user.lastName}
                          onChange={this.handleInputChange}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4}>
                        <FormControl className={classes.formControl}>
                          <InputFormat
                            label="Email"
                            placeholder="Email"
                            name="email"
                            type="email"
                            margin="normal"
                            value={user.email === null ? "" : user.email}
                            onChange={this.handleInputChange}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <InputFormat
                          select
                          label={t("profile_gender")}
                          name="sex"
                          value={user.sex === 0 ? -1 : user.sex}
                          margin="normal"
                          className={classes.selectedMenu}
                          onChange={this.handleInputChange}
                        >
                          <MenuItem key="male" value={-1}>
                            {t("profile_male")}
                          </MenuItem>
                          <MenuItem key="female" value={1}>
                            {t("profile_female")}
                          </MenuItem>
                        </InputFormat>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl className={classes.formControl}>
                          <KeyboardDatePicker
                            autoOk
                            disableFuture={true}
                            name="dob"
                            inputVariant="outlined"
                            label={t("profile_dob")}
                            format="DD/MM/YYYY"
                            value={moment(user.dob, "YYYY-MM-DD")}
                            margin="normal"
                            views={["year", "month", "date"]}
                            onChange={(date) =>
                              this.handleInputChange({
                                target: {
                                  value: date,
                                  name: "dob",
                                },
                              })
                            }
                            cancelLabel={t("date_picker_cancel")}
                            okLabel={t("date_picker_ok")}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12}>
                        <InputFormat
                          name="address"
                          label={t("profile_address")}
                          placeholder={t("profile_address")}
                          multiline
                          rowsMax="2"
                          margin="normal"
                          value={user.address === null ? "" : user.address}
                          onChange={this.handleInputChange}
                        />
                      </Grid>
                    </Grid>

                    <div className={"btn-update"}>
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        color="primary"
                        onClick={this.handleSubmit}
                      >
                        {t("profile_update")}
                      </Button>
                    </div>
                  </TabContainer>
                )}
                {tab === 1 && (
                  <TabContainer>
                    <Grid container spacing={3} className={" tab-password"}>
                      <Grid item xs={12} sm={12}>
                        <InputFormat
                          required
                          type="password"
                          label={t("profile_current_password")}
                          placeholder={t("profile_current_password")}
                          name="currentPassword"
                          value={this.state.password.currentPassword}
                          margin="normal"
                          onChange={this.handleInputPasword}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12}>
                        <InputFormat
                          required
                          type="password"
                          label={t("profile_new_password")}
                          placeholder={t("profile_new_password")}
                          name="newPassword"
                          value={this.state.password.newPassword}
                          margin="normal"
                          onChange={this.handleInputPasword}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12}>
                        <InputFormat
                          required
                          type="password"
                          label={t("profile_confirm_password")}
                          placeholder={t("profile_confirm_password")}
                          name="confirmNewPassword"
                          value={this.state.password.confirmNewPassword}
                          margin="normal"
                          onChange={this.handleInputPasword}
                        />
                      </Grid>
                    </Grid>

                    <div className={"change-password"}>
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        color="primary"
                        onClick={this.handlePassword}
                      >
                        {t("profile_update")}
                      </Button>
                    </div>
                  </TabContainer>
                )}

                {permission.apiKey && tab === 2 && (
                  <TabContainer>
                    <Grid container spacing={3} className={"tab-apikey"}>
                      <Grid item xs={12} sm={12}>
                        <InputFormat
                          required
                          type={showApiKey ? "text" : "password"}
                          label={t("profile_secretkey")}
                          placeholder={t("profile_secretkey")}
                          name="secretKey"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={this.handleShowAPIKey}>
                                  {showApiKey ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          value={apiKey.secretKey}
                          margin="normal"
                          onChange={this.handleAPIkey}
                        />
                      </Grid>
                    </Grid>

                    {permission.apiKey && (
                      <div className={"change-password"}>
                        <Button
                          variant="contained"
                          type="submit"
                          size="large"
                          color="secondary"
                          disabled={
                            permission.apiKey.delete &&
                            this.state.apiKey &&
                            this.state.apiKey.apiKey
                              ? false
                              : true
                          }
                          onClick={() => this.mDialog.handleDialogOpen()}
                        >
                          {t("profile_delete")}
                        </Button>

                        <Button
                          variant="contained"
                          type="submit"
                          size="large"
                          color="primary"
                          onClick={this.handleGeneralAPI}
                          disabled={
                            (permission.apiKey.insert && !apiKey.apiKey) ||
                            (permission.apiKey.update && apiKey.apiKey)
                              ? false
                              : true
                          }
                          style={{ marginLeft: 8 }}
                        >
                          {t("profile_general")}
                        </Button>
                      </div>
                    )}

                    <Grid container spacing={3} className={classes.apiKey}>
                      <Grid item xs={12} sm={12}>
                        <InputFormat
                          disabled
                          type="text"
                          label={t("profile_apikey")}
                          placeholder={t("profile_apikey")}
                          name="apiKey"
                          multiline
                          rows={1}
                          rowsMax={10}
                          InputProps={{
                            inputRef: this.mAPIKey,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={this.copyToClipboard}>
                                  <FileCopy />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          value={apiKey.apiKey}
                        />
                      </Grid>
                    </Grid>
                  </TabContainer>
                )}
                {(roleId.role === "ownerSpa" ||
                  roleId.role === "employeeSpa") &&
                  tab === 3 && (
                    <TabContainer>
                      <DevelopAccount
                        role="ownerSpa"
                        createSuccess={this.createDevelopAccountSuccess}
                      />
                    </TabContainer>
                  )}
              </Paper>
            </Paper>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    );
  }
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  user: state.user.user,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
  apiKey: state.serviceApiKeys.apiKey,
  module: state.user.module,
});

const mapDispatch = (dispatch) => ({
  userDispatch: dispatch.user,
  uploadDispatch: dispatch.upload,
  getAPIkey: dispatch.serviceApiKeys.get,
  createAPIkey: dispatch.serviceApiKeys.create,
  deleteAPIkey: dispatch.serviceApiKeys.delete,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Profile)));
